<template>
  <v-app id="inspire" class="grey lighten-3">
   <UserNavbar/>
   <v-main>
     <v-flex>
         <v-container
        fluid
      >
        <v-layout px-5  row class="mt-1">
          <v-flex xs11 dense>
            <div class="subtitle" style=" font-size: 0.92em;">Dashboard</div>
          </v-flex>
          <v-flex class="text-right" xs1>
            <v-spacer/>
             <v-breadcrumbs class="pa-0" :items="crumbItems" id="crumbs">
              <template v-slot:item="{item}">
                <v-breadcrumbs-item :href="item.href" :disabled="item.disabled" @click="breadCrumbClick(item)" style=" font-size: 0.92em;">
                  {{item.text}}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
        <PublicHome/>
      </v-container>
     </v-flex>
     <v-snackbar
        id="snack"
        color="#339966"
        timeout="-1"
        v-model="snackbar"
        tile
        right
        closable
        style="position: fixed; z-index: 20;"
        class="mb-6 ma-19"
      >
        <span
          style=" font-size: 0.78em;"
        >
          Register and Login to View More Analytics Visuals?
        </span>
        <v-layout  class="mt-2">
          <v-spacer/>
          <v-chip
            style=" font-size: 0.78em;"
            class="mr-2"
            @click="snackbar=!snackbar"
          >
            <v-icon
              class="mr-1 caption"
            >
              mdi-star-remove
            </v-icon>
              No Thanks
          </v-chip>
          <v-chip
            style=" font-size: 0.78em;"
            class=" ml-2"
            @click="move()"
          >
            <v-icon
              class="mr-1 caption"
            >
              mdi-star-shooting
            </v-icon>
            Yes Please
          </v-chip>
          <v-spacer/>
        </v-layout>
     </v-snackbar>
   </v-main>
  </v-app>
</template>

<script>
import UserNavbar from '@/components/PublicNavbar'
import PublicHome from '@/components/PublicHome'

export default {
  data: () => {
    return {
      snackbar: false,
      crumbItems: [
        {
          text: 'Categories',
          disabled: false,
          href: '#',
          route: '/'
        }
      ],
      headers: [ { text: 'Report Name', value: 'name' },
        { text: 'Author', value: 'report_by' },
        { text: 'Date Created', value: 'date_created' },
        { text: 'Report Type', value: 'type' }
      ]
    }
  },
  components: {
    UserNavbar,
    PublicHome
  },
  mounted () {
    this.showSnackbar()
  },
  methods: {
    showSnackbar () {
      setTimeout(() => {
        this.snackbar = true
      }, 1000 * 20)
    },
    move () {
      this.$router.push('/login')
    },
    breadCrumbClick (item) {
      this.$router.push(item.route).catch(() => {
        window.location.reload()
      })
    }
  }
}
</script>

<style scoped>
#crumbs{
  align-content: right;
  justify-content: right;
}
</style>
